import { Localized } from "@fluent/react";
import { Alert, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { useEffect, useState } from "react";
import { CancelButton } from "../../../../app/components/CancelButton";
import { DeleteButton } from "../../../../app/components/DeleteButton";

type DeleteWorkflowStageProps = {
    open: boolean;
    stageTitle?: string;
    onClose: () => void;
    onConfirm: () => void | Promise<void>;
};

export const DeleteWorkflowStage = ({ open, stageTitle, onClose, onConfirm }: DeleteWorkflowStageProps) => {
    const [isDeleting, setIsDeleting] = useState(false);

    useEffect(() => {
        if (!open) {
            setIsDeleting(false);
        }
    }, [open]);

    const handleConfirmClick = async () => {
        if (isDeleting) {
            return;
        }

        setIsDeleting(true);
        try {
            await Promise.resolve(onConfirm());
        } finally {
            setIsDeleting(false);
        }
    };

    return <Dialog open={open} fullWidth maxWidth="xs">
        <DialogTitle>
            <Localized id="document-workflow-delete-stage-title">
                <span>Usun etap</span>
            </Localized>
        </DialogTitle>
        <DialogContent>
            <Alert severity="warning" sx={{ mt: 1, fontSize: "1rem" }}>
                {stageTitle
                    ? <Localized id="document-workflow-delete-stage-question-with-name" vars={{ stageTitle }}>
                        <span>Czy na pewno usunac etap "{stageTitle}"?</span>
                    </Localized>
                    : <Localized id="document-workflow-delete-stage-question">
                        <span>Czy na pewno usunac etap?</span>
                    </Localized>}
            </Alert>
        </DialogContent>
        <DialogActions>
            <DeleteButton loading={isDeleting} onClick={handleConfirmClick} />
            <CancelButton loading={isDeleting} onClick={onClose} disabled={isDeleting} />
        </DialogActions>
    </Dialog>;
};
